<template>
    <section>
        <v-btn text class="px-0 green--text back" @click="$router.go(-1)" absolute v-if="$vuetify.breakpoint.mdAndDown">
            <svg v-svg="'icon-back'" size="11" fill="currentColor" class="mr-1"></svg>
            <span>Back</span>
        </v-btn>

        <section class="text-center mt-7 mb-4">
            <v-avatar size="208">
                <img :src="user.avatar || require('@/../public/images/Avatar.png')">
            </v-avatar>
        </section>

        <section class="text-center mb-3">
            <v-btn text class="mr-1" @click="$refs.delete.dialog = true">
                <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                <span class="red--text">Delete</span>
            </v-btn>

            <v-btn text class="mr-1" @click="generateNewPassword(user.id)">
                <svg v-svg="'icon-new-password'" size="12" class="mr-1"></svg>
                <span class="pass">Generate New Password</span>
            </v-btn>

            <v-btn text @click="[$refs.deactivate.dialog = true]" class="px-0 ml-1" :class="{'inactivate': user.status_label === 'approved' , 'activate': user.status_label === 'deactivated'}">
                <svg v-svg="'icon-status'" size="12" fill="currentColor" class="mr-1"></svg>
                <span v-if="user.status_label === 'approved'">Inactivate</span>
                <span v-else>Activate</span>
            </v-btn>
        </section>

        <section class="sectionForm mx-auto">
            <ValidationObserver v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <ValidationProvider name="Name" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field label="Name"
                                      v-model="user.name"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Surname" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field label="Surname"
                                      v-model="user.sur_name"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Phone" :rules="{required : true, regex: /([0][1|3-9]{2})([0-9]{6})/, max: 9}" v-slot="{ errors }">
                        <v-text-field label="Phone"
                                      v-model="user.phone"
                                      maxlength="9"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-phone'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                        <v-text-field label="Email"
                                      type="email"
                                      v-model="user.email"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider name="Date of Birth" rules="required" v-slot="{ errors }">
                                <v-text-field :value="user.date_of_birth"
                                              label="Date of Birth"
                                              readonly
                                              v-bind="attrs"
                                              v-on="on"
                                              :loading="loadingRequest"
                                >
                                    <template v-slot:prepend-inner>
                                        <svg v-svg="'icon-date'" size="15" class="mr-1"></svg>
                                    </template>
                                </v-text-field>
                                <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </template>

                        <v-date-picker :active-picker.sync="activePicker"
                                       v-model="user.date_of_birth"
                                       @change="$refs.menu.save($event)"
                                       :max="moment(new Date()).subtract(0, 'years').toISOString()"
                                       :min="moment(new Date()).subtract(60, 'years').toISOString()"
                                       color="green"
                        ></v-date-picker>
                    </v-menu>

                    <ValidationProvider name="Team" rules="required" v-slot="{ errors }">
                        <v-select :items="TEAMS"
                                  label="Team"
                                  item-text="name"
                                  item-value="id"
                                  v-model="user.team_id"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-members'" size="12" style="width: 15px; height: 15px" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                        <v-select :items="statuses"
                                  label="Status"
                                  item-text="name"
                                  item-value="id"
                                  v-model="user.status_id"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-study-status'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-textarea label="Feedback"
                                v-model="user.feedback"
                                rows="1"
                                auto-grow
                    >
                        <template v-slot:prepend-inner>
                            <svg v-svg="'icon-feedback'" size="15" class="mr-1"></svg>
                        </template>
                    </v-textarea>

                    <v-card-actions class="justify-center mt-10">
                        <v-btn class="white--text" color="green" type="submit" :loading="loadingSave">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="$router.go(-1)">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </section>

        <delete ref="delete" :user_id="user.id"></delete>
        <deactivate ref="deactivate" :user_id="user.id"></deactivate>
    </section>
</template>

<script>
    import Delete from '@/components/Admin/User/Delete';
    import Deactivate from '@/components/Admin/User/Deactivate';
    import {mapGetters} from 'vuex';
    export default {
        components: {
            Delete,
            Deactivate,
        },

        data(){
            return {
                user: {},
                menu: false,
                loadingRequest: false,
                loadingSave: false,
                activePicker: null,
                statuses: [
                    {name: 'In Progress', id: 1},
                    {name: 'Left Out', id: 2},
                    {name: 'Graduated', id: 3},
                ],
            }
        },

        computed: mapGetters(['TEAMS']),

        watch: {
            menu (val) {
                val && setTimeout(() => (this.activePicker = 'YEAR'))
            },
        },

        mounted() {
            this.getData();
            this.$on('getData', function () {
                this.getData();
            })
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$apiAdmin('users').show(this.$route.query.student_id).then((res) => {
                    this.user = res.data.user;
                    this.loadingRequest = false;
                })
            },

            save(){
                this.loadingSave = true;
                this.$apiAdmin('users').update(this.user, this.$route.query.student_id)
                    .then(() => {
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully updated.'});
                        this.$router.go(-1);
                    }).catch((err) => {
                    if (err.response.status === 422) this.$refs.form.setErrors(err.response.data);
                }).finally(() => {
                    this.loadingSave = false;
                })
            },

            generateNewPassword(id) {
                this.$apiAdmin('users').generateNewPassword({id}).then(() => {
                    this.$store.dispatch('alert', {type: 1, message: 'Successfully generated.'});
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../../../../scss/pages/Users/Students/singlePage";
</style>